import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from "@/app/providers";
import { logger } from "@/infra/logging";
import { ROUTES } from "@/app/router/routes";
import type { ReactNode } from 'react';

interface PublicRouteProps {
  children: ReactNode;
}

export default function PublicRoute({ children }: PublicRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');

  logger.debug('PublicRoute - checking isAuthenticated for redirect', {
    component: 'PublicRoute',
    isAuthenticated,
    isLoading,
    currentPath: window.location.pathname,
  });

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    const destination = redirect ?? ROUTES.dashboard;
    logger.info('PublicRoute - User is authenticated, redirecting', { component: 'PublicRoute', destination });
    return <Navigate to={destination} replace />;
  }

  return children;
}
